// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Resilience Hub (RESILIENCEHUB)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsresiliencehub.html
 *
 * 2025-02-24T21:49:25.547Z
 */
export enum AwsResiliencehubActions {
  /**
   * Grants permission to accept resource grouping recommendations
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_AcceptResourceGroupingRecommendations.html
   */
  AcceptResourceGroupingRecommendations = 'resiliencehub:AcceptResourceGroupingRecommendations',
  /**
   * Grants permission to add draft application version resource mappings
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_AddDraftAppVersionResourceMappings.html
   */
  AddDraftAppVersionResourceMappings = 'resiliencehub:AddDraftAppVersionResourceMappings',
  /**
   * Grants permission to include or exclude one or more operational recommendations
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_BatchUpdateRecommendationStatus.html
   */
  BatchUpdateRecommendationStatus = 'resiliencehub:BatchUpdateRecommendationStatus',
  /**
   * Grants permission to create application
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_CreateApp.html
   */
  CreateApp = 'resiliencehub:CreateApp',
  /**
   * Grants permission to create application app component
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_CreateAppVersionAppComponent.html
   */
  CreateAppVersionAppComponent = 'resiliencehub:CreateAppVersionAppComponent',
  /**
   * Grants permission to create application resource
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_CreateAppVersionResource.html
   */
  CreateAppVersionResource = 'resiliencehub:CreateAppVersionResource',
  /**
   * Grants permission to create recommendation template
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_CreateRecommendationTemplate.html
   */
  CreateRecommendationTemplate = 'resiliencehub:CreateRecommendationTemplate',
  /**
   * Grants permission to create resiliency policy
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_CreateResiliencyPolicy.html
   */
  CreateResiliencyPolicy = 'resiliencehub:CreateResiliencyPolicy',
  /**
   * Grants permission to batch delete application
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DeleteApp.html
   */
  DeleteApp = 'resiliencehub:DeleteApp',
  /**
   * Grants permission to batch delete application assessment
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DeleteAppAssessment.html
   */
  DeleteAppAssessment = 'resiliencehub:DeleteAppAssessment',
  /**
   * Grants permission to remove application input source
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DeleteAppInputSource.html
   */
  DeleteAppInputSource = 'resiliencehub:DeleteAppInputSource',
  /**
   * Grants permission to delete application app component
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DeleteAppVersionAppComponent.html
   */
  DeleteAppVersionAppComponent = 'resiliencehub:DeleteAppVersionAppComponent',
  /**
   * Grants permission to delete application resource
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DeleteAppVersionResource.html
   */
  DeleteAppVersionResource = 'resiliencehub:DeleteAppVersionResource',
  /**
   * Grants permission to batch delete recommendation template
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DeleteRecommendationTemplate.html
   */
  DeleteRecommendationTemplate = 'resiliencehub:DeleteRecommendationTemplate',
  /**
   * Grants permission to batch delete resiliency policy
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DeleteResiliencyPolicy.html
   */
  DeleteResiliencyPolicy = 'resiliencehub:DeleteResiliencyPolicy',
  /**
   * Grants permission to describe application
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeApp.html
   */
  DescribeApp = 'resiliencehub:DescribeApp',
  /**
   * Grants permission to describe application assessment
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeAppAssessment.html
   */
  DescribeAppAssessment = 'resiliencehub:DescribeAppAssessment',
  /**
   * Grants permission to describe application version
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeAppVersion.html
   */
  DescribeAppVersion = 'resiliencehub:DescribeAppVersion',
  /**
   * Grants permission to describe application version app component
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeAppVersionAppComponent.html
   */
  DescribeAppVersionAppComponent = 'resiliencehub:DescribeAppVersionAppComponent',
  /**
   * Grants permission to describe application version resource
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeAppVersionResource.html
   */
  DescribeAppVersionResource = 'resiliencehub:DescribeAppVersionResource',
  /**
   * Grants permission to describe application resolution
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeAppVersionResourcesResolutionStatus.html
   */
  DescribeAppVersionResourcesResolutionStatus = 'resiliencehub:DescribeAppVersionResourcesResolutionStatus',
  /**
   * Grants permission to describe application version template
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeAppVersionTemplate.html
   */
  DescribeAppVersionTemplate = 'resiliencehub:DescribeAppVersionTemplate',
  /**
   * Grants permission to describe draft application version resources import status
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeDraftAppVersionResourcesImportStatus.html
   */
  DescribeDraftAppVersionResourcesImportStatus = 'resiliencehub:DescribeDraftAppVersionResourcesImportStatus',
  /**
   * Grants permission to describe metrics export
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeMetricsExport.html
   */
  DescribeMetricsExport = 'resiliencehub:DescribeMetricsExport',
  /**
   * Grants permission to describe resiliency policy
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeResiliencyPolicy.html
   */
  DescribeResiliencyPolicy = 'resiliencehub:DescribeResiliencyPolicy',
  /**
   * Grants permission to describe the latest status of the grouping recommendation
   * process
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_DescribeResourceGroupingRecommendationTask.html
   */
  DescribeResourceGroupingRecommendationTask = 'resiliencehub:DescribeResourceGroupingRecommendationTask',
  /**
   * Grants permission to import resources to draft application version
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ImportResourcesToDraftAppVersion.html
   */
  ImportResourcesToDraftAppVersion = 'resiliencehub:ImportResourcesToDraftAppVersion',
  /**
   * Grants permission to list alarm recommendation
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAlarmRecommendations.html
   */
  ListAlarmRecommendations = 'resiliencehub:ListAlarmRecommendations',
  /**
   * Grants permission to list compliance drifts that were detected while running an
   * assessment
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppAssessmentComplianceDrifts.html
   */
  ListAppAssessmentComplianceDrifts = 'resiliencehub:ListAppAssessmentComplianceDrifts',
  /**
   * Grants permission to list resource drifts that were detected while running an a
   * ssessment
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppAssessmentResourceDrifts.html
   */
  ListAppAssessmentResourceDrifts = 'resiliencehub:ListAppAssessmentResourceDrifts',
  /**
   * Grants permission to list application assessment
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppAssessments.html
   */
  ListAppAssessments = 'resiliencehub:ListAppAssessments',
  /**
   * Grants permission to list app component compliances
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppComponentCompliances.html
   */
  ListAppComponentCompliances = 'resiliencehub:ListAppComponentCompliances',
  /**
   * Grants permission to list app component recommendations
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppComponentRecommendations.html
   */
  ListAppComponentRecommendations = 'resiliencehub:ListAppComponentRecommendations',
  /**
   * Grants permission to list application input sources
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppInputSources.html
   */
  ListAppInputSources = 'resiliencehub:ListAppInputSources',
  /**
   * Grants permission to list application version app components
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppVersionAppComponents.html
   */
  ListAppVersionAppComponents = 'resiliencehub:ListAppVersionAppComponents',
  /**
   * Grants permission to application version resource mappings
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppVersionResourceMappings.html
   */
  ListAppVersionResourceMappings = 'resiliencehub:ListAppVersionResourceMappings',
  /**
   * Grants permission to list application resources
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppVersionResources.html
   */
  ListAppVersionResources = 'resiliencehub:ListAppVersionResources',
  /**
   * Grants permission to list application version
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListAppVersions.html
   */
  ListAppVersions = 'resiliencehub:ListAppVersions',
  /**
   * Grants permission to list applications
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListApps.html
   */
  ListApps = 'resiliencehub:ListApps',
  /**
   * Grants permission to list metrics
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListMetrics.html
   */
  ListMetrics = 'resiliencehub:ListMetrics',
  /**
   * Grants permission to list recommendation templates
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListRecommendationTemplates.html
   */
  ListRecommendationTemplates = 'resiliencehub:ListRecommendationTemplates',
  /**
   * Grants permission to list resiliency policies
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListResiliencyPolicies.html
   */
  ListResiliencyPolicies = 'resiliencehub:ListResiliencyPolicies',
  /**
   * Grants permission to list resource grouping recommendations
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListResourceGroupingRecommendations.html
   */
  ListResourceGroupingRecommendations = 'resiliencehub:ListResourceGroupingRecommendations',
  /**
   * Grants permission to list SOP recommendations
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListSopRecommendations.html
   */
  ListSopRecommendations = 'resiliencehub:ListSopRecommendations',
  /**
   * Grants permission to list suggested resiliency policies
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListSuggestedResiliencyPolicies.html
   */
  ListSuggestedResiliencyPolicies = 'resiliencehub:ListSuggestedResiliencyPolicies',
  /**
   * Grants permission to list tags for a resource
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListTagsForResource.html
   */
  ListTagsForResource = 'resiliencehub:ListTagsForResource',
  /**
   * Grants permission to list test recommendations
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListTestRecommendations.html
   */
  ListTestRecommendations = 'resiliencehub:ListTestRecommendations',
  /**
   * Grants permission to list unsupported application version resources
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ListUnsupportedAppVersionResources.html
   */
  ListUnsupportedAppVersionResources = 'resiliencehub:ListUnsupportedAppVersionResources',
  /**
   * Grants permission to publish application version
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_PublishAppVersion.html
   */
  PublishAppVersion = 'resiliencehub:PublishAppVersion',
  /**
   * Grants permission to put draft application version template
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_PutDraftAppVersionTemplate.html
   */
  PutDraftAppVersionTemplate = 'resiliencehub:PutDraftAppVersionTemplate',
  /**
   * Grants permission to reject resource grouping recommendations
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_RejectResourceGroupingRecommendations.html
   */
  RejectResourceGroupingRecommendations = 'resiliencehub:RejectResourceGroupingRecommendations',
  /**
   * Grants permission to remove draft application version mappings
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_RemoveDraftAppVersionResourceMappings.html
   */
  RemoveDraftAppVersionResourceMappings = 'resiliencehub:RemoveDraftAppVersionResourceMappings',
  /**
   * Grants permission to resolve application version resources
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ResolveAppVersionResources.html
   */
  ResolveAppVersionResources = 'resiliencehub:ResolveAppVersionResources',
  /**
   * Grants permission to create application assessment
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_StartAppAssessment.html
   */
  StartAppAssessment = 'resiliencehub:StartAppAssessment',
  /**
   * Grants permission to start the metrics export
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_StartMetricsExport.html
   */
  StartMetricsExport = 'resiliencehub:StartMetricsExport',
  /**
   * Grants permission to start the grouping recommendation generation process
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_StartResourceGroupingRecommendationTask.html
   */
  StartResourceGroupingRecommendationTask = 'resiliencehub:StartResourceGroupingRecommendationTask',
  /**
   * Grants permission to assign a resource tag
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_TagResource.html
   */
  TagResource = 'resiliencehub:TagResource',
  /**
   * Grants permission to untag a resource
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_UntagResource.html
   */
  UntagResource = 'resiliencehub:UntagResource',
  /**
   * Grants permission to update application
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_UpdateApp.html
   */
  UpdateApp = 'resiliencehub:UpdateApp',
  /**
   * Grants permission to update application version
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_UpdateAppVersion.html
   */
  UpdateAppVersion = 'resiliencehub:UpdateAppVersion',
  /**
   * Grants permission to update application app component
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_UpdateAppVersionAppComponent.html
   */
  UpdateAppVersionAppComponent = 'resiliencehub:UpdateAppVersionAppComponent',
  /**
   * Grants permission to update application resource
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_UpdateAppVersionResource.html
   */
  UpdateAppVersionResource = 'resiliencehub:UpdateAppVersionResource',
  /**
   * Grants permission to update resiliency policy
   *
   * See https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_UpdateResiliencyPolicy.html
   */
  UpdateResiliencyPolicy = 'resiliencehub:UpdateResiliencyPolicy',
}
